module.exports = __webpack_public_path__ + "media/application/images/svgs/film-0a0d4f76b2f68df37ec876c9cf653c2e.svg";